import React, { useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Modal, List, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  setRepairDetail,
  setCenterMap,
  getCoverageAutoRoute,
} from "../../../../actions/boldgroup/repairPointAction";
import { numericInput } from "../../../../utils/utils";
import { LoadingOutlined } from "@ant-design/icons";

const CreateRepairLoopDetail = ({ item, index }) => {
  const [visibleModal, setVisibleModal] = useState(false);
  const [isLoadingCoverage, setIsLoadingCoverage] = useState(false);
  const { repairDetail, coverageLayers } = useSelector((state) => ({
    repairDetail: state.repairPoint?.repairDetail,
    coverageLayers: state.repairPoint?.coverageLayers,
  }));
  const dispatch = useDispatch();

  // const handleGetCoverageAutoRoute = useCallback(async () => {
  //   try {
  //     await dispatch(
  //       getCoverageAutoRoute({
  //         latitude: item.latitude,
  //         longitude: item.longitude,
  //         layerType: "slackloop",
  //       })
  //     );
  //   } catch (err) {
  //     console.log("error", err);
  //     // setError(err.message);
  //   }
  // }, [dispatch, item.latitude, item.longitude]);

  const handleSetMarkerDetail = (index, key, value) => {
    dispatch(
      setRepairDetail({
        ...repairDetail,
        markers: repairDetail.markers.map((s, i) => {
          if (i === index) {
            return { ...s, [key]: value };
          }
          return s;
        }),
      })
    );
  };

  const handleSetMarkerLatLng = (index, value) => {
    dispatch(
      setRepairDetail({
        ...repairDetail,
        markers: repairDetail.markers.map((s, i) => {
          if (i === index) {
            return {
              ...s,
              pkId: value.pkId,
              latitude: value.latitude,
              longitude: value.longitude,
              loopID: value.loopID,
              detail : value.detail
            };
          }
          return s;
        }),
      })
    );
  };

  const handleSetCenterMap = (location) => {
    dispatch(setCenterMap(location));
  };

  return (
    <>
      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <label className="mb-0">Latitude</label>
            <input
              className="form-control form-control-sm"
              value={item.latitude || ""}
              onChange={(event) => {
                const { value } = event.target;
                handleSetMarkerDetail(index, "latitude", numericInput(value));
              }}
              // disabled
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label className="mb-0">Longitude</label>
            <input
              className="form-control form-control-sm"
              value={item.longitude || ""}
              onChange={(event) => {
                const { value } = event.target;
                handleSetMarkerDetail(index, "longitude", numericInput(value));
              }}
              // disabled
            />
          </div>
        </div>
        {!!item.latitude && !!item.longitude && (
          <div className="col-12 text-center">
            <Button
              className="btn-search-repair-point"
              shape="round"
              icon={<SearchOutlined />}
              onClick={() => {
                handleSetCenterMap({
                  lat: +item.latitude,
                  lng: +item.longitude,
                });
                // setVisibleModal(true);
                // setIsLoadingCoverage(true);
                // handleGetCoverageAutoRoute().then(() =>
                //   setIsLoadingCoverage(false)
                // );
              }}
            >
              Search
            </Button>
          </div>
        )}
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">เส้นทางที่ loop เกาะอยู่</label>
            <input
              className="form-control form-control-sm"
              value={item.enclosure || ""}
              onChange={(event) => {
                const { value } = event.target;
                handleSetMarkerDetail(index, "enclosure", value);
              }}
            />
          </div>
        </div>
        {/* <div className="col-12">
          <div className="form-group">
            <label className="mb-0">Enclosure</label>
            <input
              className="form-control form-control-sm"
              value={item.enclosure || ""}
              onChange={(event) => {
                const { value } = event.target;
                handleSetMarkerDetail(index, "enclosure", value);
              }}
            />
          </div>
        </div> */}
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">Loop ID (ถ้ามี)</label>
            <input
              className="form-control form-control-sm"
              value={item.loopID || ""}
              disabled
              onChange={(event) => {
                const { value } = event.target;
                handleSetMarkerDetail(index, "loopID", value);
              }}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">Detail</label>
            <textarea
              className="form-control form-control-sm"
              value={item.detail || ""}
              disabled
              // onChange={(event) => {
              //   const { value } = event.target;
              //   handleSetMarkerDetail(index, "detail", value);
              // }}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">ความยาวหลังปลด</label>
            <input
              className="form-control form-control-sm"
              value={item.distanceLoop || ""}
              onChange={(event) => {
                const { value } = event.target;
                handleSetMarkerDetail(
                  index,
                  "distanceLoop",
                  numericInput(value)
                );
              }}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">บริเวณจุดเสีย หรือ อื่นๆ</label>
            <textarea
              className="form-control form-control-sm"
              value={item.remark || ""}
              onChange={(event) => {
                const { value } = event.target;
                handleSetMarkerDetail(index, "remark", value);
              }}
            />
          </div>
        </div>
      </div>
      <Modal
        title="Site ที่อยู่ใกล้เคียง"
        centered
        visible={visibleModal}
        footer={null}
        width={1000}
        height={500}
        // onOk={() => this.setModal2Visible(false)}
        onCancel={() => setVisibleModal(false)}
        className="coverage-layers"
      >
        {isLoadingCoverage ? (
          <div
            className="row justify-content-center"
            style={{ height: 200, alignItems: "center" }}
          >
            <div className="col-auto">
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />}
              />
            </div>
          </div>
        ) : (
          <List
            size="small"
            itemLayout="horizontal"
            dataSource={coverageLayers}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <Button
                    className="btn-search-repair-point"
                    shape="round"
                    onClick={() => {
                      handleSetMarkerLatLng(index, {
                        pkId: item.pkId,
                        latitude: +item.lat,
                        longitude: +item.lon,
                        loopID: item.slackloopId,
                        detail : item.note
                        // siteName: item.siteName,
                      });
                      handleSetCenterMap({
                        lat: +item.lat,
                        lng: +item.lon,
                      });
                      setVisibleModal(false);
                    }}
                  >
                    Select
                  </Button>,
                ]}
              >
                <List.Item.Meta
                  title={item.siteName}
                  description={`Note : ${item.note}, Area Code : ${item.areaCode}, Location : ${item.lat}, ${item.lon}`}
                />
              </List.Item>
            )}
          />
        )}
      </Modal>
    </>
  );
};

export default CreateRepairLoopDetail;
